module.exports = __webpack_public_path__ + "img/mj3.f831ff5e.png";